import { gql } from "@apollo/client";

export const SIGNIN_MUTATION = gql`
  mutation tokenAuth($email: String!, $password: String!) {
    tokenAuth(email: $email, password: $password) {
      token
      success
      errors
    }
  }
`;

export const COMPANY_SIGNUP_MUTATION = gql`
  mutation companyRegister(
    $email: String!
    $password: String!
    $confirmPassword: String!
    $nameEn: String!
    $nameAr: String!
    $descriptionEn: String!
    $descriptionAr: String!
    $contactPersonName: String!
    $contactPersonNumber: String!
    $logo: Upload!
  ) {
    companyRegister(
      email: $email
      password: $password
      confirmPassword: $confirmPassword
      nameEn: $nameEn
      nameAr: $nameAr
      descriptionEn: $descriptionEn
      descriptionAr: $descriptionAr
      contactPersonName: $contactPersonName
      contactPersonNumber: $contactPersonNumber
      logo: $logo
    ) {
      token
      success
      errors
    }
  }
`;

export const PARTICIPANT_SIGNUP_MUTATION = gql`
  mutation participantRegister(
    $email: String!
    $password: String!
    $confirmPassword: String!
    $fullNameEn: String!
    $fullNameAr: String!
    $civilIdNumber: String!
    $dateOfBirth: String!
    $gender: String!
    $mobileNumber: String!
    $guardianMobileNumber: String!
    $guardianRelation: String!
    $emergencyContactNumber: String!
    $emergencyContactRelation: String!
    $languages: [String]!
    $otherLanguages: String
    $chronicDiseasesYesNo: String!
    $chronicDiseases: String
    $nationality: String!
    $motherNationality: String!
    $countryOfResidence: String!
  ) {
    participantRegister(
      email: $email
      password: $password
      confirmPassword: $confirmPassword
      fullNameEn: $fullNameEn
      fullNameAr: $fullNameAr
      civilIdNumber: $civilIdNumber
      dateOfBirth: $dateOfBirth
      gender: $gender
      mobileNumber: $mobileNumber
      guardianMobileNumber: $guardianMobileNumber
      guardianRelation: $guardianRelation
      emergencyContactNumber: $emergencyContactNumber
      emergencyContactRelation: $emergencyContactRelation
      languages: $languages
      otherLanguages: $otherLanguages
      chronicDiseasesYesNo: $chronicDiseasesYesNo
      chronicDiseases: $chronicDiseases
      nationality: $nationality
      motherNationality: $motherNationality
      countryOfResidence: $countryOfResidence
    ) {
      token
      success
      errors
    }
  }
`;

export const UPDATE_APPLICATION_PANEL_MUTATION = gql`
  mutation updateApplicationPanel(
    $applicationPanelId: ID!
    $formType: String
    $companySelection: Boolean
    $onlinePayments: Boolean
    $applicationLimit: Int
    $participationFees: Int
    $participantsAgeFrom: Int
    $participantsAgeTo: Int
    $malesWhatsappCommunityLink: String
    $femalesWhatsappCommunityLink: String
    $aboutProgram: String
    $applicationRequirements: String
    $requiredDocuments: String
    $programRequirements: String
    $generalNotes: String
  ) {
    updateApplicationPanel(
      applicationPanelId: $applicationPanelId
      formType: $formType
      companySelection: $companySelection
      onlinePayments: $onlinePayments
      applicationLimit: $applicationLimit
      participationFees: $participationFees
      participantsAgeFrom: $participantsAgeFrom
      participantsAgeTo: $participantsAgeTo
      malesWhatsappCommunityLink: $malesWhatsappCommunityLink
      femalesWhatsappCommunityLink: $femalesWhatsappCommunityLink
      aboutProgram: $aboutProgram
      applicationRequirements: $applicationRequirements
      requiredDocuments: $requiredDocuments
      programRequirements: $programRequirements
      generalNotes: $generalNotes
    ) {
      success
      errors
    }
  }
`;

export const NEW_REGISTRATION_MUTATION = gql`
  mutation newRegistration(
    $valuesYouBelieveIn: String!
    $howDidYouKnowAboutTheProgram: String!
    $mediaSkillsYesNo: String
    $mediaSkills: String
    $mediaFields: [String]
    $civilId: Upload!
    $personalImage: Upload!
    $ibanNumber: Upload!
    $tshirtSize: String!
    $specialRequest: String
    $programRequirements: Boolean!
    $correctInformation: Boolean!
  ) {
    newRegistration(
      valuesYouBelieveIn: $valuesYouBelieveIn
      howDidYouKnowAboutTheProgram: $howDidYouKnowAboutTheProgram
      mediaSkillsYesNo: $mediaSkillsYesNo
      mediaSkills: $mediaSkills
      mediaFields: $mediaFields
      civilId: $civilId
      personalImage: $personalImage
      ibanNumber: $ibanNumber
      tshirtSize: $tshirtSize
      specialRequest: $specialRequest
      programRequirements: $programRequirements
      correctInformation: $correctInformation
    ) {
      success
      showFullyBookedMessage
      errors
    }
  }
`;

export const PAYMENT_METHODS_LIST_MUTATION = gql`
  mutation paymentMethodsList($total: Float) {
    paymentMethodsList(total: $total) {
      paymentMethods
      success
      errors
    }
  }
`;

export const NEW_TRANSACTION_MUTATION = gql`
  mutation newTransaction(
    $paymentMethodId: Int!
    $registrationId: Int
    $orderId: String
    $total: Float
  ) {
    newTransaction(
      paymentMethodId: $paymentMethodId
      registrationId: $registrationId
      orderId: $orderId
      total: $total
    ) {
      paymentUrl
      success
      errors
    }
  }
`;

export const PARTICIPANT_PROFILE_UPDATE = gql`
  mutation participantProfileUpdate(
    $userId: Int!
    $email: String!
    $inputData: ParticipantProfileInput!
  ) {
    participantProfileUpdate(userId: $userId, email: $email, inputData: $inputData) {
      success
      errors
      token
    }
  }
`;

export const NEW_COMPANY_REQUEST_MUTATION = gql`
  mutation newCompanyRequest(
    $trainingType: String!
    $specialRequirements: String!
    $certificateCopy: Upload
    $interviewersInfoForm: [InterviewerInput!]!
    $locationsInfoForm: [LocationInput!]!
    $accurateInformation: Boolean!
  ) {
    newCompanyRequest(
      trainingType: $trainingType
      specialRequirements: $specialRequirements
      certificateCopy: $certificateCopy
      interviewersInfoForm: $interviewersInfoForm
      locationsInfoForm: $locationsInfoForm
      accurateInformation: $accurateInformation
    ) {
      success
      errors
    }
  }
`;

export const EDIT_COMPANY_REQUEST_MUTATION = gql`
  mutation editCompanyRequest(
    $requestId: ID!
    $trainingType: String!
    $specialRequirements: String!
    $certificateCopy: Upload
    $interviewersInfoForm: [InterviewerInput!]!
    $locationsInfoForm: [LocationInput!]!
    $accurateInformation: Boolean!
  ) {
    editCompanyRequest(
      requestId: $requestId
      trainingType: $trainingType
      specialRequirements: $specialRequirements
      certificateCopy: $certificateCopy
      interviewersInfoForm: $interviewersInfoForm
      locationsInfoForm: $locationsInfoForm
      accurateInformation: $accurateInformation
    ) {
      success
      errors
    }
  }
`;

export const UPDATE_REGISTRATION_STATUS_MUTATION = gql`
  mutation updateRegistration($registrationId: ID!, $status: String!) {
    updateRegistration(registrationId: $registrationId, status: $status) {
      registration {
        id
        status
      }
    }
  }
`;

export const UPDATE_PAYMENT_STATUS_MUTATION = gql`
  mutation updateRegistration($registrationId: ID!, $paymentStatus: String!) {
    updateRegistration(registrationId: $registrationId, paymentStatus: $paymentStatus) {
      registration {
        id
        status
      }
    }
  }
`;

export const ASSIGN_TO_COMPANY_MUTATION = gql`
  mutation updateRegistration($registrationId: ID!, $assignedJobOpportunity: ID!) {
    updateRegistration(
      registrationId: $registrationId
      assignedJobOpportunity: $assignedJobOpportunity
    ) {
      registration {
        id
        assignedJobOpportunity {
          id
        }
      }
    }
  }
`;

export const REMOVE_FROM_COMPANY_MUTATION = gql`
  mutation removeFromCompany($registrationId: ID!) {
    removeFromCompany(registrationId: $registrationId) {
      registration {
        id
      }
    }
  }
`;

export const CAN_CHECK_IN_OUT_MUTATION = gql`
  mutation canCheckInOut($registrationId: ID!, $date: Date!) {
    canCheckInOut(registrationId: $registrationId, date: $date) {
      canCheckIn
      canCheckOut
      success
      errors
    }
  }
`;

export const NEW_ATTENDANCE_RECORD = gql`
  mutation newAttendanceRecord(
    $registrationId: ID!
    $date: Date!
    $checkInTime: Time
    $checkOutTime: Time
    $checkInLatitude: Float
    $checkInLongitude: Float
    $checkOutLatitude: Float
    $checkOutLongitude: Float
  ) {
    newAttendanceRecord(
      registrationId: $registrationId
      date: $date
      checkInTime: $checkInTime
      checkOutTime: $checkOutTime
      checkInLatitude: $checkInLatitude
      checkInLongitude: $checkInLongitude
      checkOutLatitude: $checkOutLatitude
      checkOutLongitude: $checkOutLongitude
    ) {
      success
      errors
      eventType
    }
  }
`;

export const COMPANY_PROFILE_UPDATE = gql`
  mutation companyProfileUpdate($userId: Int!, $email: String!, $inputData: CompanyProfileInput!) {
    companyProfileUpdate(userId: $userId, email: $email, inputData: $inputData) {
      success
      errors
      token
    }
  }
`;

export const SEND_CONTACT_US_MESSAGE = gql`
  mutation sendEmail(
    $name: String!
    $mobileNumber: String!
    $email: String
    $subject: String!
    $message: String!
  ) {
    sendEmail(
      name: $name
      mobileNumber: $mobileNumber
      email: $email
      subject: $subject
      message: $message
    ) {
      success
    }
  }
`;

export const SEND_WHATSAPP_MESSAGE_MUTATION = gql`
  mutation sendWhatsapp($templateName: String!, $to: String!) {
    sendWhatsapp(templateName: $templateName, to: $to) {
      success
      errors
    }
  }
`;

export const SIGNUP_WITH_GOOGLE_MUTATION = gql`
  mutation signupWithGoogle($fullName: String!, $email: String!, $uid: String!) {
    signupWithGoogle(email: $email, fullName: $fullName, uid: $uid) {
      token
      success
      errors
    }
  }
`;

export const ACCOUNT_VERIFICATION_MUTATION = gql`
  mutation accountVerification($otpCode: String!) {
    accountVerification(otpCode: $otpCode) {
      token
      success
      errors
    }
  }
`;

export const RESEND_OTP_CODE_MUTATION = gql`
  mutation resendOtpCode {
    resendOtpCode {
      success
      errors
    }
  }
`;

export const SEND_PASSWORD_RESET_EMAIL_MUTATION = gql`
  mutation sendPasswordResetEmail($email: String!) {
    sendPasswordResetEmail(email: $email) {
      success
      errors
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation resetPassword(
    $uid: String!
    $token: String!
    $newPassword: String!
    $confirmNewPassword: String!
  ) {
    resetPassword(
      uid: $uid
      token: $token
      newPassword: $newPassword
      confirmNewPassword: $confirmNewPassword
    ) {
      success
      errors
    }
  }
`;

export const CHECK_IF_EMAIL_EXISTS_MUTATION = gql`
  mutation checkIfEmailExists($email: String!) {
    checkIfEmailExists(email: $email) {
      exists
      success
      errors
    }
  }
`;

export const UPDATE_DEVICE_ID_MUTATION = gql`
  mutation updateDeviceId($deviceId: String!) {
    updateDeviceId(deviceId: $deviceId) {
      success
      errors
    }
  }
`;

export const VERIFY_DEVICE_ID_MUTATION = gql`
  mutation verifyDeviceId($deviceId: String!) {
    verifyDeviceId(deviceId: $deviceId) {
      verified
      success
      errors
    }
  }
`;

export const NEW_ABSENCE_REQUEST_MUTATION = gql`
  mutation newAbsenceRequest($registrationId: ID!, $date: Date!, $reason: String!) {
    newAbsenceRequest(registrationId: $registrationId, date: $date, reason: $reason) {
      success
      errors
    }
  }
`;

export const UPDATE_ABSENCE_REQUEST_STATUS_MUTATION = gql`
  mutation updateAbsenceRequest($absenceRequestId: ID!, $status: String!) {
    updateAbsenceRequest(absenceRequestId: $absenceRequestId, status: $status) {
      success
      errors
    }
  }
`;

export const NEW_ORDER_MUTATION = gql`
  mutation newOrder($productsList: [OrderProductInput!]!) {
    newOrder(productsList: $productsList) {
      success
      errors
      orderId
    }
  }
`;

export const UPDATE_ORDER_MUTATION = gql`
  mutation updateOrder($orderId: ID!, $status: String!) {
    updateOrder(orderId: $orderId, status: $status) {
      success
      errors
    }
  }
`;
